export enum UserTierType {
  Tier1 = 1,
  Tier2 = 2,
  Tier3 = 3,
  Tier4 = 4,
  Tier5 = 5,
  Tier6 = 6,
  Tier7 = 7,
}

export const UserTierTypeText: Record<UserTierType, string> = {
  [UserTierType.Tier1]: "Tier 1",
  [UserTierType.Tier2]: "Tier 2",
  [UserTierType.Tier3]: "Tier 3",
  [UserTierType.Tier4]: "Tier 4",
  [UserTierType.Tier5]: "Tier 5",
  [UserTierType.Tier6]: "Tier 6",
  [UserTierType.Tier7]: "Tier 7",
};

export const UserTierTypeTextShort: Record<UserTierType, string> = {
  [UserTierType.Tier1]: "T1",
  [UserTierType.Tier2]: "T2",
  [UserTierType.Tier3]: "T3",
  [UserTierType.Tier4]: "T4",
  [UserTierType.Tier5]: "T5",
  [UserTierType.Tier6]: "T6",
  [UserTierType.Tier7]: "T7",
};
